import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlBaseLegal = '/service/contabilidade/baseLegal/'

class BaseLegalService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getBaseLegal() {
        return this.conex.get(urlBaseLegal + 'todos/')
    }
}

export default BaseLegalService
